<template>
  <v-card class="p-2" outlined>
    <v-skeleton-loader
      v-bind="attrs"
      type="card-heading, image, actions"
      v-if="loading"
    />

    <div
      :class="{
        'hide-component': loading,
      }"
    >
      <card-chart-header
        title="Certifications"
        subtitle="points are clickable"
        :getData="getData"
      />

      <div class="position-relative" style="min-height: 400px">
        <v-overlay absolute :value="overlay">
          <h4>No "Certifications" data found!</h4>
        </v-overlay>

        <GChart
          type="PieChart"
          :data="chartData"
          :options="chartOptions"
          :settings="{ packages: ['corechart'] }"
          :createChart="(el, google) => new google.visualization.LineChart(el)"
          :events="chartEvents"
          ref="gchart"
          id="chart"
          v-show="!overlay"
        />
      </div>
    </div>
  </v-card>
</template>

<script>
import CardChartHeader from '@/components/client-reports/widgets/CardChartHeader.vue';

function defaultChartData() {
  return [['Name', 'Value']];
}

export default {
  name: 'Certification',

  components: { CardChartHeader },

  props: ['model', 'showChartDialog', 'getData'],

  data() {
    return {
      chartData: defaultChartData(),
      chartOptions: {
        title: '',
        subtitle: 'labels are clickable',
        chartArea: {
          width: '90%',
          height: '80%',
        },
        legend: 'none',
        vAxis: {
          format: "#'%'",
          minValue: 0,
          maxValue: 100,
        },
        pointSize: 7,
      },

      chartEvents: {
        select: this.chartOnSelect,
        ready: this.toggleLoading,
      },

      loading: true,

      overlay: false,
    };
  },

  methods: {
    chartOnSelect() {
      const data = this.$refs.gchart.getValidChartData();
      const table = this.$refs.gchart.chartObject;
      const selection = table.getSelection();

      for (let i = 0; i < selection.length; i++) {
        const item = selection[i];
        if (item.row === null && item.column === null) {
          continue;
        }

        const category = data.getValue(selection[0].row, 0);

        this.showChartDialog(
          'certificates',
          category,
          `Certificate: ${category}`
        );
      }
    },

    // eslint-disable-next-line consistent-return
    initializeChart() {
      if (this.model.certifications.length < 1) {
        console.log(this.model);
        this.overlay = true;
        this.loading = false;
        return;
      }

      this.overlay = false;

      this.chartData = defaultChartData();

      Object.keys(this.model.certifications).forEach((key) => {
        this.chartData.push([key, this.model.certifications[key]]);
      });
    },

    toggleLoading() {
      this.loading = false;
    },
  },
};
</script>

<style lang="stylus">
#chart
  height 400px
</style>
